import { render, staticRenderFns } from "./PrincipalInformations.vue?vue&type=template&id=f40869a6&"
import script from "./PrincipalInformations.vue?vue&type=script&lang=js&"
export * from "./PrincipalInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports